<h1>New Product</h1>

<form [formGroup]="newProductForm" #f="ngForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="f.submitted && newProductForm.invalid">
        <ul>
            <li *ngIf="f.submitted && newProductForm.controls['productName'].invalid">Product Name can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['sectionId'].invalid">Section can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['price'].invalid">Price can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['offerFrom'].invalid">Offer From can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['offerTo'].invalid">Offer To can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['offerType'].invalid">Offer Type can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['offerValue'].invalid">Offer Value can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['stock'].invalid">Stock can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['limitPerOrder'].invalid">Limit Per Order can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.controls['limitPerDay'].invalid">Limit Per Day can't be empty.</li>
            <li *ngIf="f.submitted && newProductForm.errors?.exists">Product already exists.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="productName">Product Name</label>
        <input
            id="productName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="productName"
            [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['productName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="sectionId">Section</label>
        <ng-select
            [items]="sections"
            bindLabel="sectionName"
            bindValue="sectionId"
            formControlName="sectionId"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['sectionId'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="price">Price</label>
        <input
            id="price"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="price"
            digitOnly
            [decimal]="true"
            [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['price'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="address">Description</label>
        <textarea
            id="desc"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="desc"
            [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['desc'].invalid }"
        >
        </textarea>
    </div>
    <div class="form-group">
        <label for="specialDiscount">Special Discount</label>
        <input
            id="specialDiscount"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="specialDiscount"
            digitOnly
            [decimal]="true"
            [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['specialDiscount'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="index">Order</label>
        <input
            id="index"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="index"
            digitOnly
            [decimal]="false"
            [ngClass]="{ 'input-validation-error': newProductForm.touched && newProductForm.controls['index'].invalid }"
        />
    </div>
    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="isPublished" formControlName="isPublished" class="custom-control-input" />
            <label for="isPublished" class="custom-control-label cursor-pointer">is Published</label>
        </div>
    </div>

    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="markAsNew" formControlName="markAsNew" class="custom-control-input" />
            <label for="markAsNew" class="custom-control-label cursor-pointer">Mark As New</label>
        </div>
    </div>

    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="hasOffer" formControlName="hasOffer" class="custom-control-input" />
            <label for="hasOffer" class="custom-control-label cursor-pointer">Has Offer</label>
        </div>
    </div>

    <div class="form-group" *ngIf="newProductForm.controls['hasOffer'].value">
        <div class="asset-container">
            <div class="asset-container-header">Offer</div>
            <div class="asset-container-content">
                <div class="form-group">
                    <label for="offerFrom">Offer From</label>
                    <input
                        id="offerFrom"
                        class="form-control w-md-25"
                        type="datetime-local"
                        formControlName="offerFrom"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['offerFrom'].invalid }"
                    />
                </div>
                <div class="form-group">
                    <label for="offerTo">Offer To</label>
                    <input
                        id="offerTo"
                        class="form-control w-md-25"
                        type="datetime-local"
                        formControlName="offerTo"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['offerTo'].invalid }"
                    />
                </div>
                <div class="form-group">
                    <label for="offerType">Offer Type</label>
                    <ng-select
                        [items]="offerType"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="offerType"
                        class="w-md-25"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['offerType'].invalid }"
                    >
                    </ng-select>
                </div>
                <div class="form-group">
                    <label for="offerValue">Offer Value</label>
                    <input
                        id="offerValue"
                        class="form-control w-md-25"
                        type="text"
                        formControlName="offerValue"
                        digitOnly
                        [decimal]="true"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['offerValue'].invalid }"
                    />
                </div>
                <div class="form-group">
                    <label for="stock">Stock</label>
                    <input
                        id="stock"
                        class="form-control w-md-25"
                        type="text"
                        formControlName="stock"
                        digitOnly
                        [decimal]="false"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['stock'].invalid }"
                    />
                </div>
                <div class="form-group">
                    <label for="limitPerOrder">Limit Per Order</label>
                    <input
                        id="limitPerOrder"
                        class="form-control w-md-25"
                        type="text"
                        formControlName="limitPerOrder"
                        digitOnly
                        [decimal]="false"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['limitPerOrder'].invalid }"
                    />
                </div>
                <div class="form-group">
                    <label for="limitPerDay">Limit Per Day</label>
                    <input
                        id="limitPerDay"
                        class="form-control w-md-25"
                        type="text"
                        formControlName="limitPerDay"
                        digitOnly
                        [decimal]="false"
                        [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['limitPerDay'].invalid }"
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="form-group">
        <div class="asset-container" [ngClass]="{ 'input-validation-error': f.submitted && newProductForm.controls['assetId'].invalid }">
            <div class="asset-container-header">Image</div>

            <div class="asset-container-content">
                <div class="title mb-2">Image</div>
                <div class="toolbar btn-group mb-2">
                    <button class="btn btn-secondary btn-sm" type="button" (click)="openMedia()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path
                                fill="currentColor"
                                d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                            ></path>
                        </svg>
                    </button>
                    <button class="btn btn-secondary btn-sm" type="button" [disabled]="!selectAsset" (click)="clearImages()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path
                                fill="currentColor"
                                d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                            ></path>
                        </svg>
                    </button>
                </div>

                <div class="card" *ngIf="!selectAsset">
                    <div class="card-body">
                        <span class="hint"> No Images </span>
                    </div>
                </div>

                <div class="images" *ngIf="selectAsset">
                    <div class="image">
                        <div class="content">
                            <img src="/thumbs/{{ selectAsset.assetId }}/small/{{ selectAsset.assetFriendlyName }}" />
                        </div>
                        <div class="title" title="{{ selectAsset.assetName }}">
                            <div class="mini-toolbar">
                                <button type="button" class="btn btn-light btn-sm" (click)="clearImages()">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path
                                            fill="currentColor"
                                            d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                                        ></path>
                                    </svg>
                                </button>
                                <a
                                    class="btn btn-light btn-sm"
                                    [routerLink]="['/thumbs', selectAsset.assetId, 'large', selectAsset.assetFriendlyName]"
                                    target="_blank"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path
                                            fill="currentColor"
                                            d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                        ></path>
                                    </svg>
                                </a>
                            </div>
                            <span> {{ selectAsset.assetName }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Create</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
